module.exports = __webpack_public_path__ + "media/images/fmdd-small-logo-95adee12d33ace302465b6f51bb15d6f.jpg";